import React from "react";
import { makeStyles } from "tss-react/mui";
import { Checkbox, FormControlLabel } from "@mui/material";

/**
 * @param {Object} props
 * @param {string|React.ReactNode} [props.label]
 * @param {string} [props.name]
 * @param {boolean} [props.value]
 * @param {function} [props.handleChange]
 * @param {string} [props.labelPlacement]
 * @param {boolean} [props.disableRipple]
 * @param {boolean} [props.disabled]
 * @param {node} [props.icon]
 * @param {node} [props.checkedIcon]
 * @param {string} [props.color]
 * @param {object} [props.style]
 * @param {string} [props.size]
 * @param {object} [props.labelStyle]
 * @returns {JSX.Element}
 */

export function MiCheckbox({
  label = "",
  name = "",
  value = false,
  handleChange,
  labelPlacement = "end",
  disableRipple = false,
  disabled = false,
  icon = undefined,
  checkedIcon = undefined,
  color = "primary",
  style = {},
  size = "medium",
  labelStyle = {},
}) {
  const { classes } = useStyles();

  return (
    <FormControlLabel
      className={classes.checkbox}
      data-testid={`mi-checkbox-${name}`}
      sx={{ ...labelStyle }}
      control={
        <Checkbox
          checked={value}
          onChange={handleChange}
          disabled={disabled}
          disableRipple={disableRipple}
          icon={icon}
          color={color}
          checkedIcon={checkedIcon}
          style={style}
          size={size}
        />
      }
      label={label}
      labelPlacement={labelPlacement}
    />
  );
}

const useStyles = makeStyles()(() => ({
  checkbox: { margin: 0 },
}));
